export default __webpack_public_path__ + "static/media/logo.59b531ae.png";